import React, { useRef } from 'react';
import { Icon } from '@doxyme/ui';
import { useProgress, PROGRESS_DEFAULT_RESET, } from '../../helpers/use-progress';
export const ProgressButton = ({ isLoading, hasError, progress, slowFactor = 1, reset = PROGRESS_DEFAULT_RESET, children, ...rest }) => {
    const containerRef = useRef();
    const barRef = useRef();
    useProgress(isLoading, hasError, reset, slowFactor, progress, containerRef, barRef);
    return (<button {...rest} ref={containerRef}>
      <span className="progress">
        <span className="progress-inner" ref={barRef}/>
      </span>

        <span className="progress-content">
        <span className="progress-default">{children}</span>

        <span className="progress-success">
          <Icon name="ok" className="icon ok" size="x-small"/>
        </span>

        <span className="progress-error">
          <Icon name="close-old" className="icon close" size="x-small"/>
        </span>
      </span>
      </button>);
};
